import { render, staticRenderFns } from "./ReportsOrderHistory.vue?vue&type=template&id=f6f7a234&"
import script from "./ReportsOrderHistory.vue?vue&type=script&lang=js&"
export * from "./ReportsOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportsOrderHistory.vue?vue&type=style&index=0&id=f6f7a234&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports